/* eslint-disable camelcase */

// @noflow
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Moment from 'moment';
import { setVideoProgress, setPlayingOnCastDevice } from 'Common/cast/actions';
import { extendMoment } from 'moment-range';
import { SourceType } from 'Common/models/franchise';

import { changeActiveReceiver } from '../app/actions';
import {
  clearQvtInterval,
  dismissAsyncPopup,
  dismissTunersPopup,
  dockMiniPlayer,
  fetchAiringsData,
  fetchLiveVideoMetadata,
  fetchQvt,
  fetchVideoMetadata,
  llEventTransition,
  playerStreamLoaded,
  postToRecents,
  putToRecents,
  resetDVRStatus,
  resetPlayer,
  setDVRStream,
  setLiveStream,
  setPlaybackCouldNotBeStarted,
  setPlayerProgramInfo,
  setPlayerStream,
  setSlingPlaybackInfo,
  setSlingPlayerConnectionMode,
  setSlingPlayerError,
  setSlingPlayerLoading,
  setSlingPlayerStatus,
  setPlayerSessionActive,
  setDebugModeEnabled,
  showAsyncPopup,
  showTunersPopup,
  slingPlayerConnect,
  slingPlayerPlay,
  slingPlayerStop,
  toggleDebugInfo,
  togglePlayerContainer,
  togglePlayerVisibility,
  toggleUnsupportedReceiverModal,
  undockMiniPlayer,
  resetPlayerStream,
  startPlaybackInProgress,
  startPlaybackFromBeginning,
  setPlayerError,
  setSlingErrorsObject,
  resetSlingErrorsObject,
  setSlingPlayerEventObject,
  setPlayerEventObject,
  setPlayerLastActive,
  setPlayerPageOpened,
} from './actions';
import { createTimer, requestReceiversStatus } from '../dvr/actions';
import { updateContentProgress, postViewContent } from '../est/actions';
import { setFranchiseProgress } from '../franchise/actions';
import { registerDynaDevice } from '../preferences/actions';
import playerEvents from './slingplayer/events';
import { playListing } from './playListing';

const moment = extendMoment(Moment);

let slingApi = null;
let playerApi = null;

const setSlingApi = ref => {
  slingApi = ref;
};

const setPlayerApi = ref => {
  playerApi = ref;
};

const callBitmovinApi = (fn, ...args) => {
  let bitmovinResponse;

  if (!playerApi) {
    console.warn('withPlayer callBitmovinApi called before playerApi init', playerApi);
    return bitmovinResponse;
  }

  if (!fn || !playerApi[fn]) {
    console.warn('withPlayer callBitmovinApi invalid function', fn);
    return bitmovinResponse;
  }

  if (!args) {
    args = [];
  }

  try {
    bitmovinResponse = playerApi[fn](...args);
  } catch (e) {
    console.warn('withPlayer callBitmovinApi exception');
  }

  console.log(`withPlayer callBitmovinApi response ${fn}`, bitmovinResponse);

  return bitmovinResponse;
};

let count = 0;

export default function withPlayer(WrappedComponent) {
  class PlayerWrapper extends React.Component {
    static defaultProps = {
      activeReceiver: {},
    };

    static propTypes = {
      activeReceiver: PropTypes.object,
      airings: PropTypes.array,
      asyncPopupInfo: PropTypes.object,
      changeActiveReceiver: PropTypes.func.isRequired,
      changeReceiverError: PropTypes.bool,
      changeReceiverFetching: PropTypes.bool,
      channel: PropTypes.object,
      clearQvtInterval: PropTypes.func,
      registerDynaDevice: PropTypes.func.isRequired,
      connectionMode: PropTypes.string,
      containerOpen: PropTypes.bool,
      createTimer: PropTypes.func.isRequired,
      dismissAsyncPopup: PropTypes.func.isRequired,
      dismissTunersPopup: PropTypes.func.isRequired,
      dockMiniPlayer: PropTypes.func.isRequired,
      dvrId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      dvrProgress: PropTypes.number,
      env: PropTypes.string,
      fetchAiringsData: PropTypes.func.isRequired,
      fetchLiveVideoMetadata: PropTypes.func.isRequired,
      fetchQvt: PropTypes.func.isRequired,
      fetchVideoMetadata: PropTypes.func.isRequired,
      onDemandListing: PropTypes.object,
      miniPlayer: PropTypes.bool,
      nextQvtPayload: PropTypes.object,
      playbackCouldNotBeStarted: PropTypes.bool,
      playerKey: PropTypes.string.isRequired,
      playerStreamLoaded: PropTypes.func,
      playerType: PropTypes.string,
      playerVisible: PropTypes.bool,
      playerErrorCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      playerErrorResponseText: PropTypes.string,
      playerErrorResponseCode: PropTypes.string,
      playerErrorType: PropTypes.string,
      playerErrorName: PropTypes.string,
      playerErrorServerResponse: PropTypes.any,
      postViewContent: PropTypes.func.isRequired,
      programInfo: PropTypes.object,
      putToRecents: PropTypes.func.isRequired,
      putToRecentsError: PropTypes.object,
      putToRecentsFinished: PropTypes.bool,
      qvtPayload: PropTypes.object,
      resetDVRStatus: PropTypes.func.isRequired,
      resetPlayer: PropTypes.func.isRequired,
      setDVRStream: PropTypes.func.isRequired,
      setLiveStream: PropTypes.func.isRequired,
      setPlaybackCouldNotBeStarted: PropTypes.func.isRequired,
      setPlayerProgramInfo: PropTypes.func.isRequired,
      setPlayerError: PropTypes.func.isRequired,
      setSlingPlayerConnectionMode: PropTypes.func.isRequired,
      setSlingPlayerError: PropTypes.func.isRequired,
      setSlingPlayerLoading: PropTypes.func.isRequired,
      setSlingPlayerStatus: PropTypes.func.isRequired,
      resetSlingErrorsObject: PropTypes.func.isRequired,
      slingErrors: PropTypes.object,
      showAsyncPopup: PropTypes.func.isRequired,
      showTunersPopup: PropTypes.func.isRequired,
      slingPlaybackInfo: PropTypes.object,
      setSlingPlaybackInfo: PropTypes.func.isRequired,
      setPlayerSessionActive: PropTypes.func.isRequired,
      slingPlayerConnect: PropTypes.func.isRequired,
      slingPlayerConnected: PropTypes.bool,
      slingPlayerError: PropTypes.bool,
      slingPlayerErrorMessage: PropTypes.string,
      slingPlayerErrorReason: PropTypes.string,
      slingPlayerErrorType: PropTypes.string,
      slingPlayerErrorObject: PropTypes.object,
      slingPlayerLoading: PropTypes.bool,
      slingPlayerPlay: PropTypes.func.isRequired,
      slingPlayerPlaying: PropTypes.bool,
      slingPlayerStatus: PropTypes.string,
      slingPlayerStop: PropTypes.func.isRequired,
      setSlingErrorsObject: PropTypes.func.isRequired,
      setSlingPlayerEventObject: PropTypes.func.isRequired,
      setPlayerEventObject: PropTypes.func.isRequired,
      setPlayerLastActive: PropTypes.func.isRequired,
      setPlayerPageOpened: PropTypes.func.isRequired,
      setDebugModeEnabled: PropTypes.func.isRequired,
      debugModeEnabled: PropTypes.bool,
      sourceType: PropTypes.string,
      stream: PropTypes.object,
      streamLoaded: PropTypes.bool,
      toggleDebugInfo: PropTypes.func.isRequired,
      togglePlayerVisibility: PropTypes.func.isRequired,
      toggleUnsupportedReceiverModal: PropTypes.func.isRequired,
      tunersPopupInfo: PropTypes.object,
      undockMiniPlayer: PropTypes.func.isRequired,
      unsupportedReceiverReason: PropTypes.string,
      updateContentProgress: PropTypes.func.isRequired,
      videoMetadata: PropTypes.object,
      viewContentReference: PropTypes.object,
      viewer: PropTypes.object,
      currentProfileRole: PropTypes.string,
      isInternetReachable: PropTypes.bool,
      resetPlayerStream: PropTypes.func.isRequired,
      startPlaybackInProgress: PropTypes.func.isRequired,
      startPlaybackFromBeginning: PropTypes.func.isRequired,
      resumePlayback: PropTypes.bool.isRequired,
    };

    componentDidMount() {
      count += 1;
      this.id = count;
    }

    componentDidUpdate(prevProps) {
      if (this.id !== count) return;

      const {
        stream: { qvtUrl } = {},
        qvtPayload,
        nextQvtPayload: { fetching: nextQvtFetching = false },
        fetchQvt,
      } = this.props;

      if (this.isLiveLinear) {
        if (qvtPayload.self && qvtPayload.self !== prevProps.qvtPayload.self && !nextQvtFetching) {
          fetchQvt(qvtPayload._next, true);
        }
      }
    }

    componentWillUnmount() {
      count -= 1;
    }

    get playerUiCss() {
      const { appVersion, danyBaseUrl } = this.props;

      return `${danyBaseUrl}/assets/ui/css/bitmovinplayer-ui.min.css?version=${appVersion}`;
    }

    get playerUiJs() {
      const { appVersion, danyBaseUrl } = this.props;

      return `${danyBaseUrl}/assets/ui/js/bitmovinplayer-ui.min.js?version=${appVersion}`;
    }

    get isLiveLinear() {
      const { sourceType } = this.props;
      return sourceType === SourceType.LIVE_LINEAR;
    }

    get isLiveSling() {
      const { sourceType } = this.props;
      return sourceType === SourceType.SLING_LIVE;
    }

    get isSlingDvr() {
      const { sourceType } = this.props;
      return sourceType === SourceType.SLING_DVR;
    }

    handleOnTimeChanged = progress => {
      const { castEnabled, sourceType, setVideoProgress } = this.props;
      if (castEnabled && (sourceType === SourceType.EST || sourceType === SourceType.ON_DEMAND)) {
        setVideoProgress(Math.floor(progress));
      }
    };

    isConsecutiveSlingError = errorCode => {
      const { slingErrors } = this.props;
      let isConsecutive = false;
      const errors =
        slingErrors.errors[errorCode] && slingErrors.errors[errorCode].length >= 2
          ? slingErrors.errors[errorCode]
          : slingErrors.errors.all;

      if (errors && errors.length >= 2) {
        const prevError = errors[errors.length - 2];
        const currError = errors[errors.length - 1];

        const range = moment.range(prevError.timestamp, currError.timestamp);
        const diff = range.diff('minutes');

        if (diff <= 5) {
          isConsecutive = true;
        } else {
          isConsecutive = false;
        }
      }
      return isConsecutive;
    };

    playListing = async ({
      channelInformation,
      franchise,
      listing,
      navigation,
      title,
      trailer,
      listingType,
      watchFromStart,
      savedProgress,
    }) => {
      const {
        registerDynaDevice,
        setDVRStream,
        setLiveStream,
        setPlayerStream,
        togglePlayerVisibility,
        activeReceiver,
        toggleUnsupportedReceiverModal,
        playerType,
        cast,
        isInternetReachable,
        requestReceiversStatus,
        minSupportedChromeVersion,
      } = this.props;

      playListing({
        channelInformation,
        franchise,
        listing,
        navigation,
        title,
        trailer,
        slingApi,
        cast,
        listingType,
        watchFromStart,
        savedProgress,
        extraProps: {
          registerDynaDevice,
          setDVRStream,
          setLiveStream,
          setPlayerStream,
          togglePlayerVisibility,
          activeReceiver,
          toggleUnsupportedReceiverModal,
          playerType,
          isInternetReachable,
          requestReceiversStatus,
          minSupportedChromeVersion,
        },
      });
    };

    getProps = () => {
      const {
        activeReceiver,
        airings,
        asyncPopupInfo,
        channel,
        registerDynaDevice,
        channelInfo,
        clearQvtInterval,
        connectionMode,
        containerOpen,
        contentId,
        dismissAsyncPopup,
        dismissTunersPopup,
        dockMiniPlayer,
        dvrId,
        dvrListing,
        dvrProgress,
        env,
        fetchAiringsData,
        fetchLiveVideoMetadata,
        fetchQvt,
        fetchVideoMetadata,
        isSeeking,
        onDemandListing,
        miniPlayer,
        nextQvtPayload,
        playbackCouldNotBeStarted,
        playerKey,
        playerStreamLoaded,
        playerType,
        playerVisible,
        playerErrorCode,
        playerErrorResponseText,
        playerErrorResponseCode,
        playerErrorType,
        playerErrorName,
        playerErrorServerResponse,
        postToRecents,
        postViewContent,
        putToRecents,
        qvtPayload,
        resetDVRStatus,
        resetPlayer,
        requestReceiversStatus,
        setDVRStream,
        setLiveStream,
        setPlaybackCouldNotBeStarted,
        setPlayerProgramInfo,
        setSlingPlaybackInfo,
        setSlingPlayerConnectionMode,
        setSlingPlayerError,
        setSlingPlayerLoading,
        setSlingPlayerStatus,
        setPlayerSessionActive,
        setPlayerLastActive,
        setPlayerPageOpened,
        setDebugModeEnabled,
        debugModeEnabled,
        showAsyncPopup,
        showTunersPopup,
        slingPlaybackInfo,
        slingPlayerConnect,
        slingPlayerConnected,
        slingPlayerError,
        slingPlayerErrorMessage,
        slingPlayerErrorReason,
        slingPlayerErrorType,
        slingPlayerErrorCode,
        slingPlayerErrorObject,
        slingPlayerLoading,
        slingPlayerPlay,
        slingPlayerPlaying,
        slingPlayerStatus,
        slingPlayerStop,
        slingPlayerEventObject,
        slingSessionActive,
        sourceType,
        stream,
        streamLoaded,
        toggleDebugInfo,
        togglePlayerVisibility,
        toggleUnsupportedReceiverModal,
        tunersPopupInfo,
        undockMiniPlayer,
        unsupportedReceiverReason,
        updateContentProgress,
        videoMetadata,
        viewContentReference,
        viewer,
        currentProfileRole,
        resetPlayerStream,
        startPlaybackInProgress,
        startPlaybackFromBeginning,
        resumePlayback,
        minSupportedChromeVersion,
        setSlingErrorsObject,
        resetSlingErrorsObject,
        slingErrors,
        setFranchiseProgress,
        playerEventObject,
      } = this.props;

      return {
        ...this.props,
        activeReceiver,
        airings,
        asyncPopupInfo,
        callBitmovinApi,
        channel,
        channelInfo,
        clearQvtInterval,
        connectionMode,
        containerOpen,
        contentId,
        dismissAsyncPopup,
        dismissTunersPopup,
        dockMiniPlayer,
        dvrId,
        dvrListing,
        dvrProgress,
        env,
        fetchAiringsData,
        fetchLiveVideoMetadata,
        fetchQvt,
        fetchVideoMetadata,
        isSeeking,
        onDemandListing,
        miniPlayer,
        nextQvtPayload,
        playbackCouldNotBeStarted,
        playerApi,
        playerEvents,
        playerKey,
        playerStreamLoaded,
        playerType,
        playerUiCss: this.playerUiCss,
        playerUiJs: this.playerUiJs,
        playerVisible,
        playerErrorCode,
        playerErrorResponseText,
        playerErrorResponseCode,
        playerErrorType,
        playerErrorName,
        playerErrorServerResponse,
        playListing: this.playListing,
        postToRecents,
        postViewContent,
        putToRecents,
        qvtPayload,
        registerDynaDevice,
        resetDVRStatus,
        resetPlayer,
        requestReceiversStatus,
        setDVRStream,
        setLiveStream,
        setPlaybackCouldNotBeStarted,
        setPlayerApi,
        setPlayerProgramInfo,
        setSlingApi,
        setSlingPlaybackInfo,
        setSlingPlayerConnectionMode,
        setSlingPlayerError,
        setSlingPlayerLoading,
        setSlingPlayerStatus,
        setPlayerSessionActive,
        setPlayerLastActive,
        setPlayerPageOpened,
        setDebugModeEnabled,
        debugModeEnabled,
        showAsyncPopup,
        showTunersPopup,
        slingApi,
        slingPlaybackInfo,
        slingPlayerConnect,
        slingPlayerConnected,
        slingPlayerError,
        slingPlayerErrorMessage,
        slingPlayerErrorReason,
        slingPlayerErrorType,
        slingPlayerErrorCode,
        slingPlayerErrorObject,
        slingPlayerLoading,
        slingPlayerPlay,
        slingPlayerPlaying,
        slingPlayerStatus,
        slingPlayerStop,
        slingPlayerEventObject,
        slingSessionActive,
        sourceType,
        stream,
        streamLoaded,
        toggleDebugInfo,
        togglePlayerVisibility,
        toggleUnsupportedReceiverModal,
        tunersPopupInfo,
        undockMiniPlayer,
        unsupportedReceiverReason,
        updateContentProgress,
        videoMetadata,
        viewContentReference,
        viewer,
        currentProfileRole,
        resetPlayerStream,
        startPlaybackInProgress,
        startPlaybackFromBeginning,
        resumePlayback,
        minSupportedChromeVersion,
        setFranchiseProgress,
        setSlingErrorsObject,
        resetSlingErrorsObject,
        slingErrors,
        isConsecutiveSlingError: this.isConsecutiveSlingError,
        playerEventObject,
        handleOnTimeChanged: this.handleOnTimeChanged,
      };
    };

    render() {
      return <WrappedComponent {...this.getProps()} />;
    }
  }

  return connect(
    state => ({
      activeReceiver: state.app.activeReceiver || {},
      airings: state.player.airings,
      appVersion: state.config.appVersion,
      asyncPopupInfo: state.player.asyncPopupInfo,
      changeReceiverError: state.player.changeReceiverError,
      changeReceiverFetching: state.player.changeReceiverFetching,
      channel: state.player.channel,
      channelInfo: state.player.channelInfo,
      connectionMode: state.player.connectionMode,
      containerOpen: state.player.containerOpen,
      contentId: state.player.contentId,
      danyBaseUrl: state.config.session?.dany_base_url,
      debugVisible: state.player.debugVisible,
      dvrId: state.player.dvrId,
      dvrListing: state.player.dvrListing,
      dvrProgress: state.player.dvrProgress,
      env: state.config.base?.env,
      inputId: state.player.inputId,
      inputType: state.player.inputType,
      isNativePlayerInFullscreen: state.player.isNativePlayerInFullscreen,
      isSeeking: state.player.isSeeking,
      onDemandListing: state.player.listing,
      miniPlayer: state.player.miniPlayer,
      recentVideoId: state.player.recentVideoId,
      nextQvtPayload: state.player.nextQvtPayload,
      playbackCouldNotBeStarted: state.player.playbackCouldNotBeStarted,
      playerKey: state.config.bitmovin.player_key,
      minSupportedChromeVersion: state.config.session.min_supported_chrome_version,
      playerType: state.player.playerType,
      playerVisible: state.player.playerVisible,
      playerErrorCode: state.player.playerErrorCode,
      playerErrorResponseText: state.player.playerErrorResponseText,
      playerErrorResponseCode: state.player.playerErrorResponseCode,
      playerErrorType: state.player.playerErrorType,
      playerErrorName: state.player.playerErrorName,
      playerErrorServerResponse: state.player.playerErrorServerResponse,
      playerLastActive: state.player.playerLastActive,
      postToRecentsError: state.player.postToRecentsError,
      programInfo: state.player.programInfo,
      putToRecentsError: state.player.putToRecentsError,
      putToRecentsFinished: state.player.putToRecentsFinished,
      qvtPayload: state.player.qvtPayload,
      resumePlayback: state.player.resumePlayback,
      slingPlaybackInfo: state.player.slingPlaybackInfo,
      slingPlayerConnected: state.player.slingPlayerConnected,
      slingPlayerError: state.player.slingPlayerError,
      slingPlayerErrorMessage: state.player.slingPlayerErrorMessage,
      slingPlayerErrorReason: state.player.slingPlayerErrorReason,
      slingPlayerErrorType: state.player.slingPlayerErrorType,
      slingPlayerErrorCode: state.player.slingPlayerErrorCode,
      slingPlayerErrorObject: state.player.slingPlayerErrorObject,
      slingPlayerLoading: state.player.slingPlayerLoading,
      slingPlayerPlaying: state.player.slingPlayerPlaying,
      slingPlayerStatus: state.player.slingPlayerStatus,
      slingPlayerEventObject: state.player.slingPlayerEventObject,
      slingSessionActive: state.player.slingSessionActive,
      sourceType: state.player.sourceType,
      stream: state.player.stream,
      streamLoaded: state.player.streamLoaded,
      tunersPopupInfo: state.player.tunersPopupInfo,
      unsupportedReceiverModalOpen: state.player.unsupportedReceiverModalOpen,
      unsupportedReceiverReason: state.player.unsupportedReceiverReason,
      videoMetadata: state.player.metadata,
      viewContentReference: state.est.viewContent.content,
      viewer: state.auth.viewer,
      currentProfileRole: state.profiles.currentProfile?.profile?.role,
      cast: state.cast,
      isInternetReachable: state.networkInfo.isInternetReachable,
      slingErrors: state.player.slingErrors,
      playerEventObject: state.player.playerEventObject,
      debugModeEnabled: state.player.debugModeEnabled,
      castEnabled: state.config.cast.enabled,
    }),
    {
      changeActiveReceiver,
      clearQvtInterval,
      createTimer,
      dismissAsyncPopup,
      dismissTunersPopup,
      dockMiniPlayer,
      fetchAiringsData,
      fetchLiveVideoMetadata,
      fetchQvt,
      fetchVideoMetadata,
      llEventTransition,
      playerStreamLoaded,
      postToRecents,
      postViewContent,
      putToRecents,
      registerDynaDevice,
      resetDVRStatus,
      resetPlayer,
      requestReceiversStatus,
      setDVRStream,
      setLiveStream,
      setPlaybackCouldNotBeStarted,
      setPlayerProgramInfo,
      setPlayerStream,
      setSlingPlaybackInfo,
      setSlingPlayerConnectionMode,
      setSlingPlayerError,
      setSlingPlayerLoading,
      setSlingPlayerStatus,
      setSlingPlayerEventObject,
      setPlayerEventObject,
      setPlayerLastActive,
      setPlayerPageOpened,
      showAsyncPopup,
      showTunersPopup,
      slingPlayerConnect,
      slingPlayerPlay,
      slingPlayerStop,
      toggleDebugInfo,
      togglePlayerContainer,
      togglePlayerVisibility,
      toggleUnsupportedReceiverModal,
      undockMiniPlayer,
      updateContentProgress,
      setPlayingOnCastDevice,
      resetPlayerStream,
      startPlaybackInProgress,
      startPlaybackFromBeginning,
      setPlayerError,
      setSlingErrorsObject,
      setFranchiseProgress,
      resetSlingErrorsObject,
      setPlayerSessionActive,
      setDebugModeEnabled,
      setVideoProgress,
    },
    null,
    {
      withRef: true,
    },
  )(PlayerWrapper);
}
